export enum ReportType {
  USER_GUIDE = 'USER_GUIDE',
  RELEASE_NOTES = 'RELEASE_NOTES',
}

export enum Language {
  EN = 'EN',
  DE = 'DE',
  FR = 'FR',
  IT = 'IT',
  ES = 'ES',
}

export enum FileType {
  PDF = 'PDF',
  CSV = 'CSV',
  DOC = 'DOC',
  DOCX = 'DOCX',
  XLS = 'XLS',
  XLSX = 'XLSX',
}
